import React from 'react';
import { NavLink } from 'react-router-dom';
import { __t } from '../../../../../../base/utils/t';

import './styles.scss';

export const NavBar = () => {
    return (
        <div className='underlined-page-nav'>
            <NavLink end className='underlined-page-nav__link' to='/vacancy/active'>
                {__t('Открытые')}
            </NavLink>
            <NavLink end className='underlined-page-nav__link' to='/vacancy/draft'>
                {__t('Черновики')}
            </NavLink>
            <NavLink end className='underlined-page-nav__link' to='/vacancy/archived'>
                {__t('Закрытые')}
            </NavLink>
        </div>
    );
};
